import { Injectable } from '@angular/core';
import { Credential } from '../models/credential.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject} from 'rxjs';
import { tap } from 'rxjs/operators';
import { PeriodService } from '../services/periods.service';
import { OrdersService } from '../services/orders.service';
import { CasherService } from '../services/casher.service';

@Injectable({
    providedIn: 'root'
  })
  export class LoginService {

  private isAuthenticatedSubject = new BehaviorSubject<boolean>(false);
  public isAuthenticated = this.isAuthenticatedSubject.asObservable();  

  private userSubject = new BehaviorSubject<any>(null);
  public user = this.userSubject.asObservable();

    constructor(
      private http: HttpClient,
      private periodService: PeriodService,
      private ordersService:OrdersService,
      private casherService: CasherService
    ) { }

    getAuthToken(): string | null {
    return localStorage.getItem('ACCESS_TOKEN');
    }

    setAuthToken(token: string): void {
      localStorage.setItem('ACCESS_TOKEN', token);
    }

    removeAuthToken(): void {
      localStorage.removeItem('ACCESS_TOKEN');
    }

    login(credentials: Credential) {
      const headers = new HttpHeaders({
      'expiresIn': 'true'
    });
      return this.http.post<any>(`${environment.url_api}/auth/login`, credentials, { headers })
      .pipe(
        tap(res => {
          // Almacenar el token en el local storage
          localStorage.setItem('ACCESS_TOKEN', res.token);
          localStorage.setItem('REFRESH_TOKEN', res.tokenRefresh);
          localStorage.setItem('EMAIL', res.user.email);
          localStorage.setItem('ROLE', res.user.role);
          localStorage.setItem('USERID',res.user.id);
          if(res.user.seller != null){
            localStorage.setItem('STOREID', res.user.seller.store.id);
            localStorage.setItem('STORE', res.user.seller.store.socialName);
          }
          if(res.user.cashier != null){
            localStorage.setItem('CASHIERID',res.user.cashier.id);
            localStorage.setItem('NAME',res.user.cashier.name);
            localStorage.setItem('LASTNAME', res.user.cashier.lastName);
            localStorage.setItem('SUPERVISOR', res.user.cashier.isSupervisor);
            this.casherService.setSupervisor(res.user.cashier.isSupervisor);
            if(res.user.cashier.store != null){
              localStorage.setItem('STOREID', res.user.cashier?.store?.id);
              localStorage.setItem('STORE', res.user.cashier?.store?.socialName);
            }
          }
          this.isAuthenticatedSubject.next(true);
          this.userSubject.next(res.user);
        })
      );
    }

    verifiedSupervisor(credentials: Credential) {
      return this.http.post<any>(`${environment.url_api}/auth/login`, credentials);
    }

    logout() {
      // Eliminar el token del local storage
      localStorage.clear();
      this.isAuthenticatedSubject.next(false);
      this.userSubject.next(null);
      this.periodService.setOpenCashRegister(null);
      this.ordersService.setOpenCashRegister(null);
    }

    isAuthenticateds() {
      return this.isAuthenticatedSubject.value;
    }

    hasAnyRole(roles: string[]): boolean {
      const user = this.userSubject.value;
      return user && roles.some(role => user.role === role);
    }

    getUser() {
      return this.userSubject.value;
    }

    refresh(){
      const user = {role:localStorage.getItem('ROLE')};
      this.isAuthenticatedSubject.next(true);
      this.userSubject.next(user);
    }

    refreshToken(){
      const refreshToken = localStorage.getItem('REFRESH_TOKEN');
      return this.http.post<any>(`${environment.url_api}/auth/refresh-token`, {refreshToken});
    }
  }
